import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type State =
  | 'completed'
  | 'current'
  | 'available'
  | 'locked'
  | 'coming_soon';

export type LockReason =
  | 'previous_not_finished'
  | 'purchase_required'
  | 'waiting_for_cycle'
  | 'subscription_inactive';

/** One program as the member sees it (drafts are never listed). */
export type V = {
  '@id': string;
  '@type': 'UserProgram';
  id: string;
  number: number;
  title: string;
  totalWeeks: number;
  state: State;
  participationId: string | null;
  /** Once started */
  progress: {
    status: 'not_started' | 'in_progress' | 'paused' | 'finished';
    currentWeekNumber: number | null;
  } | null;
  startDate: string | null;
  endDate: string | null;
  pause: { startDate: string; endDate: string } | null;
  lockReasons: Array<LockReason>;
  unlocksAt: string | null;
};

export function useReadCollection(userId: string, options?: ReadConfig) {
  return useApiRead<HydraCollection<V>>(`/users/${userId}/programs`, options);
}
